(($) => {
  $(() => {
    const $printOrder = $('#print-order');

    if ($printOrder.length)
      $printOrder.on('click', () => {
        window.print();
      });
  });
})(jQuery);
